import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup, Container,Image, Progress} from "semantic-ui-react"

import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import MinOrderFreeValue from "components/Cart/MinOrderFreeValue"
import queryString from "qs"

@observer
export default class LoginLinkHover extends Component {

	constructor() {
		super()
		this.state = {
			sum: 0,
            showCalc:   false,
		}
	}
    componentDidMount() {
    }


	render() {
        let { located } = this.props

        //console.log("shop.config",shop.config)
        //console.log("shop.session",shop.cart.data.deliveraddress)
        //console.log("aboveMinFree",aboveMinFree, shippingCosts, sum, MIN_ORDER_FREE_VALUE)
		
        if(located == "HeaderMenu"){
            return (
                <div className="CartButton relative">
                    <Button
                        style={{width: "60px", height: "40px", borderRadius: "20px", backgroundColor: "#ffffff", }}
                        primary
                        id="loginLinkHover"
                        className=""
                        onMouseEnter={() => this.setState({ showCalc: true })}
                        onMouseLeave={() => {
                            this.leaveTimeout = setTimeout(() => {
                                this.setState({ showCalc: false });
                            }, 100);
                        }}
                        onMouseOver={() => {
                            if (this.leaveTimeout) {
                                clearTimeout(this.leaveTimeout);
                                this.leaveTimeout = null;
                            }
                        }}
                    >
                        <p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <Popup trigger={
                                <React.Fragment>
                                    <p className="f2 pt1">
                                        <Icon name="user " style={{color: "#646363ff"}} />
                                    </p>
                                </React.Fragment>
                            }>
                            </Popup>
                        </p>
                    </Button>
                    <div className="">
                        {this.state.showCalc && (
                            <div
                                onMouseEnter={() => {
                                    if (this.leaveTimeout) {
                                        clearTimeout(this.leaveTimeout);
                                        this.leaveTimeout = null;
                                    }
                                    this.setState({ showCalc: true });
                                }}
                                onMouseLeave={() => {
                                    this.leaveTimeout = setTimeout(() => {
                                        this.setState({ showCalc: false });
                                    }, 100);
                                }}
                                style={{ padding: 0, width: "10px", alignContent: "center", zIndex: "99", background: "transparent", animation: "fadeIn 0.5s" }}
                                className="absolute bg-white z-99  variantsContainer "
                            >
                                <div style={{ alignContent: "center", width: "350px", zIndex: "99", marginLeft: "-150px", borderRadius: "20px", marginTop: "15px" }} className="justify-between bg-white pa3 VariantsPullDownCart shadow-4">
                                    <div style={{backgroundColor: "#ffffffff"}} className="">
                                        <table className="pb3">
                                            <tbody>
                                                <tr>
                                                    <td className="tc pa3 bb b--black-10">
                                                        <p className="tl fw5">{translate("Sie sind bereits Kunde?")}</p>
                                                        <Button
                                                            style={{ minWidth: "280px", height: "45px", borderRadius: "35px", margin: 0, display: "flex", alignItems: "center", justifyContent: "center" }}
                                                            as={Link}
                                                            to={`/login/?referrer=${document.location.pathname}?login`}
                                                            primary
                                                        >
                                                            <p className="f5 fw5"><Icon name={"white power off"}/>{translate("Bestandskunden anmelden")}</p>
                                                        </Button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="tc pa3">
                                                        <p className="tl fw5">{translate("Sie sind Neukunde?")}</p>
                                                        <Button
                                                            style={{ minWidth: "280px", height: "45px", borderRadius: "35px", margin: 0, display: "flex", alignItems: "center", justifyContent: "center" }}
                                                            as={Link}
                                                            to={`/login/?referrer=${document.location.pathname}?register`}
                                                            primary
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <p className="f5 fw5"><Icon name={"white file text"}/>{translate("Neukundenanmeldung")}</p>
                                                        </Button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            );
        }
        if(located == "ProductPage"){
            return (
                <div  className=" bg-white" >
                    <div  className="justify-between bg-white ">
                        

                    </div></div>
            )
        }
	}
}





// WEBPACK FOOTER //
// ./src/theme/demo2025/components/LoginLinkHover.js